import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import {useState, useEffect, useRef} from 'react';
import SearchIcon from '@mui/icons-material/Search';
import FacebookRoundedIcon from '@mui/icons-material/FacebookRounded';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import classesCss from './Header.module.css';
import Dropdowns from "../Dropdowns/Dropdowns";
import SearchBar from "../../Components/SearchBar/SearchBar";
import RightDrawer from "../RightDrawer/RightDrawer";
import SuperExpressive from 'super-expressive';


const Header = ({headerStyles, URLS}) => {
	const [drawerState, setDrawerState] = useState({
		right: false,
		top: false
	});
	const [currentAnchor, setCurrentAnchor] = useState('top');
	const [collapse, setCollapse] = useState(false);
	const [rightDrawerWidth, setRightDrawerWidth] = useState(400);
	const [headerSearchBar, setHeaderSearchBar] = useState('90px');
	const defaultHeaderContainerStyles = {
		backgroundColor: '#D27924',
		transition: 'all 0.5s',
	};
	const defaultHeaderStyles = {
		height: '90px',
		display: 'flex',
		transition: 'all 0.5s',
	};
	const [subDropdown, setSubDropdown] = useState("15px 30px 15px 30px");
	const [menuDropdown, setMenuDropdown] = useState('45px');
	const collapseWidth = 930;
	const rightDrawerCollapse = 600;
	const scrollChangeY = 130;
	const headerIconColor = "white";
	const headerIconSize = 17;
	const header_appBar = useRef(null);
	const header__toolBar = useRef(null);
	const [headerLinkFontSize, setHeaderLinkFontSize] = useState('14px');
	const dropdowns = [
        {
            sub: {
                text: "About Us",
                url: URLS.About
            },
            items: Object.entries(URLS).reduce((current, [key, value]) => {
            	const discounted = [URLS['About'], URLS['Foundation'], URLS['Mission']];
	        	const regex = SuperExpressive()
	        				  .startOfInput
	        				  .string('/about')
	        				  .zeroOrMore
	        				  .anyChar
	        				  .toRegex();
			    if (value.search(regex) === 0 && !discounted.includes(value)) {
			    	current.push({
			    		text: key,
			    		url: value,
			    	});
			    }
			    return current;
            }, [
            	{
            		text: 'Overview',
            		url: URLS.About,
            	}
            ])
        },
        {
            sub: {
                text: "Our Work",
                url: URLS.Programs
            },
            items: Object.entries(URLS).reduce((current, [key, value]) => {
            	const discounted = [URLS['Programs']];
	        	const regex = SuperExpressive()
	        				  .startOfInput
	        				  .string('/programs')
	        				  .zeroOrMore
	        				  .anyChar
	        				  .toRegex();
			    if (value.search(regex) === 0 && !discounted.includes(value)) {
			    	current.push({
			    		text: key,
			    		url: value,
			    	});
			    }
			    return current;
            }, [
            	{
            		text: 'Overview',
            		url: URLS.Programs,
            	}
            ])
        }
    ];
    const links = [
        {
            url: URLS.Join,
            text: "Join Us"
        }
    ];

	//componentDidMount and componentDidUpdate
	useEffect(() => {
		if (window.innerWidth < collapseWidth) {
			setCollapse(true)
		}

		if (window.innerWidth < rightDrawerCollapse) {
			setRightDrawerWidth('100vw')
		}
	}, []);

	window.addEventListener("resize", () => {
		if (window.innerWidth < rightDrawerCollapse && rightDrawerWidth !== "100vw") {
			setRightDrawerWidth('100vw')
		} else if (window.innerWidth > rightDrawerCollapse && rightDrawerWidth !== 300) {
			setRightDrawerWidth(300)
		}

		if (!collapse && window.innerWidth < collapseWidth) {
			setCollapse(true);
		} else if (collapse && window.innerWidth > collapseWidth) {
			setCollapse(false);
		}
	});

	window.addEventListener('scroll', () => {
		if (window.scrollY > scrollChangeY) {
			// changes to small
			if (header_appBar.current !== null) {
				header_appBar.current.style.boxShadow = "none";
			}

			if (header__toolBar.current !== null) {
				header__toolBar.current.style.height = "70px";
			}
			if (subDropdown !== "10px 30px 10px 30px" && menuDropdown !== "36px") {
				setSubDropdown("10px 30px 10px 30px");
				setMenuDropdown('36px');
			}

			if (headerSearchBar !== "70px") {
				setHeaderSearchBar('70px');
			}
		} else {
			// changes to large
			if (header_appBar.current !== null) {
				header_appBar.current.style.boxShadow = "0 2px 4px -1px rgba(0,0,0,0.2), 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12)";
			}

			if (header__toolBar.current !== null) {
				header__toolBar.current.style.height = "90px";
			}
			if (subDropdown !== "15px 30px 15px 30px" && menuDropdown !== "45px") {
				setSubDropdown("15px 30px 15px 30px");
				setMenuDropdown("45px");
			}

			if (headerSearchBar !== "90px") {
				setHeaderSearchBar('90px');
			}
		}

	});

	const toggleDrawer = (anchor,open) => (event) => {
    	if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
    	  return;
    	}

    	if (anchor === "top") {
    		if (open === false) {
    			setTimeout(() => {
					setDrawerState({
						...drawerState,
						[anchor]: open
					});
					setCurrentAnchor(anchor);
				}, 600);
				document.getElementById("top-searchbar-bottom").style.transform = "scaleX(0)"
			} else {
    			setTimeout(() => {
					document.getElementById("top-searchbar-bottom").style.transform = "scaleX(1)"
				}, 800);
				setDrawerState({
					...drawerState,
					[anchor]: open
				});
				setCurrentAnchor(anchor);
    		}
		} else {
			setDrawerState({
				...drawerState,
				[anchor]: open
			});
			setCurrentAnchor(anchor);
		}
  	};

	return (
		<AppBar sx={defaultHeaderContainerStyles} ref={header_appBar}>
		  <Toolbar variant="dense" sx={defaultHeaderStyles} ref={header__toolBar}>
			<Typography variant="h6" color="inherit" component="div">
			  Logo
			</Typography>
			  {
			  	!collapse ? <Dropdowns dropdowns={dropdowns} links={links} fontSize={headerLinkFontSize}
									   menuHeight={menuDropdown} headerHeight={subDropdown}/> : null
			  }
			<Drawer
				anchor={currentAnchor}
				open={drawerState[currentAnchor]}
				onClose={toggleDrawer(currentAnchor, false)}
			>
				{
					currentAnchor === 'top' ? <SearchBar height={headerSearchBar} close={toggleDrawer('top', false)}/> :
						<RightDrawer close={toggleDrawer('right', false)}
									 firstPage={
									 	{
									 		dropdowns: [
												 {
													text: dropdowns[0].sub.text,
												 },
												 {
													text: dropdowns[1].sub.text,
												 },
												 {
													text: "Share",
												 }
											],
											links,
										}
									 }
									 secondPage={
										 [
											 {
												 [dropdowns[0].sub.text]: dropdowns[0].items
											 },
											 {
												 [dropdowns[1].sub.text]: dropdowns[1].items,
											 },
											 {
											 	"Share": [
													{
														text: "Facebook",
														url: "/share-facebook",
													},
													{
														text: "Twitter",
														url: "/share-twitter",
													},
													{
														text: "Linkdn",
														url: "/share-linkdn",
													},
													{
														text: "Instagram",
														url: "/share-instagram",
													},
												]
											 }
										 ]
									 }
									 rightDrawerWidth={rightDrawerWidth}/>
				}
			</Drawer>
			<div className={"flex justify-center items-center"} style={{marginLeft: 'auto'}}>
				{
					!collapse ?
						<div className={"flex mr-3 justify-start"}>
							<IconButton sx={{color: headerIconColor,}}
										onClick={toggleDrawer('top', true)}>
								<SearchIcon sx={{
									fontSize: headerIconSize,
								}}/>
							</IconButton>
							<IconButton sx={{color: headerIconColor}}>
								<FacebookRoundedIcon sx={{
									fontSize: headerIconSize,
								}}/>
							</IconButton>
							<IconButton sx={{color: headerIconColor}}>
								<TwitterIcon sx={{
									fontSize: headerIconSize,
								}}/>
							</IconButton>
							<IconButton sx={{color: headerIconColor}}>
								<LinkedInIcon sx={{
									fontSize: headerIconSize,
								}}/>
							</IconButton>
							<IconButton sx={{color: headerIconColor}}>
								<InstagramIcon sx={{
									fontSize: headerIconSize,
								}}/>
							</IconButton>
						</div> : null
				}
				<a href={URLS.Checkout} className={classesCss.header__donate}>DONATE</a>
				{
					collapse ?
						<IconButton sx={{
							marginLeft: '10px',
							marginRight: '10px',
						}} edge="start" color="inherit" aria-label="menu" onClick={toggleDrawer('right', true)}>
							<MenuIcon />
						</IconButton> :
						null
				}
			</div>
		  </Toolbar>
		</AppBar>
	);
};

export default Header;
